/**
 * appLauncher.js
 * Utilidades para detectar dispositivos móviles y abrir la app nativa D-SIDE
 * si el usuario la tiene instalada en su teléfono.
 */

export const isAndroidDevice = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = (navigator.userAgent || navigator.vendor || window.opera || '').toLowerCase();
  return ua.includes('android');
};

export const isIOSDevice = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = (navigator.userAgent || navigator.vendor || window.opera || '').toLowerCase();
  return /iphone|ipad|ipod/.test(ua);
};

export const isMobileDevice = () => {
  return isAndroidDevice() || isIOSDevice();
};

/**
 * Detecta si la web ya se está ejecutando dentro del WebView de la app móvil
 * para evitar loops o intentos redundantes.
 */
export const isInsideAppWebView = () => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
  
  // React Native WebView inyecta window.ReactNativeWebView
  if (window.ReactNativeWebView) return true;

  const ua = (navigator.userAgent || '').toLowerCase();
  if (ua.includes('dside') || ua.includes('eldenguee') || ua.includes('wv') || ua.includes('version/4.0')) {
    // Si contiene markers de webview específico
    if (ua.includes('dside') || ua.includes('eldenguee')) return true;
  }
  return false;
};

/**
 * Convierte una ruta web a la ruta correspondiente en la app mobile
 */
export const getAppRoute = (pathname = '') => {
  const clean = pathname.replace(/^\//, '').split('?')[0];
  if (!clean || clean === 'home') return 'open';
  if (clean.startsWith('tipeos') || clean === 'bonos' || clean === 'menu-tipeos') return 'bonos';
  if (clean === 'shop' || clean === 'tienda') return 'shop';
  if (clean === 'guias') return 'guias';
  if (clean === 'rankings') return 'rankings';
  if (clean === 'mis-solicitudes') return 'mis-solicitudes';
  if (clean.startsWith('sorteo/')) {
    const id = clean.replace(/^sorteo\//, '');
    return `sorteos/${id}`;
  }
  if (clean.startsWith('sorteos/')) {
    return clean;
  }
  if (clean === 'sorteo' || clean === 'sorteos') return 'sorteos';
  if (clean === 'ruleta') return 'ruleta';
  if (clean === 'canjear') return 'canjear';
  if (clean === 'notificaciones') return 'notificaciones';
  return clean;
};

/**
 * Construye el Intent URL para Android Chrome / Navegadores Android
 * Formato estándar de Android Intent:
 * intent://[path]#Intent;scheme=eldenguee;package=com.dside;end
 */
export const getAndroidIntentUrl = (pathname = window.location.pathname) => {
  const appRoute = getAppRoute(pathname);
  return `intent://${appRoute}#Intent;scheme=eldenguee;package=com.dside;end`;
};

/**
 * URL de esquema directo (eldenguee://...)
 */
export const getCustomSchemeUrl = (pathname = window.location.pathname) => {
  const appRoute = getAppRoute(pathname);
  return `eldenguee://${appRoute}`;
};

/**
 * Intenta abrir la app de forma directa si está instalada.
 * - En Android usa el Android Intent URI (reconocido nativamente por Android OS).
 * - En iOS usa el Custom Scheme eldenguee://.
 */
export const launchApp = (pathname = window.location.pathname) => {
  if (typeof window === 'undefined') return;

  if (isAndroidDevice()) {
    const intentUrl = getAndroidIntentUrl(pathname);
    window.location.href = intentUrl;
  } else if (isIOSDevice()) {
    const customUrl = getCustomSchemeUrl(pathname);
    window.location.href = customUrl;
  }
};
